import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import classes from './Dashboard.module.scss';
import { Typography } from 'antd';
import Container from 'shared/ui/Container/Container';
import Plan from '../components/Plan';
import { EMI } from 'shared/model/types';
import { getEMIAccounts } from 'shared/config/store/reducers/accountsSlice';
import { RootState } from 'shared/config/store/store';
import { getCards } from 'shared/config/store/reducers/cardsSlice';
import { getUserMeta } from 'shared/config/store/reducers/userSlice';
import NoPlans from '../components/NoPlans/NoPlans';
import TransactionsView from 'widgets/transactions/ui/TransactionsView';
import { VerificationWidget } from 'widgets/verification';

const Dashboard = () => {
  const { formatMessage: t } = useIntl();
  const user = useSelector(getUserMeta);

  const accounts = {
    [EMI.Wallester]: useSelector((state: RootState) => getEMIAccounts(state, EMI.Wallester))
  };
  const cards = {
    [EMI.Wallester]: useSelector(getCards(EMI.Wallester))
  };

  // Get first account ID for transactions
  const wallesterAccounts = accounts[EMI.Wallester];
  const firstAccountId = wallesterAccounts && Object.keys(wallesterAccounts).length > 0 
    ? Number(Object.keys(wallesterAccounts)[0]) 
    : null;

  return (
    <>
      <Container className={classes.wrapper}>
        <div className={classes.container}>
          {!Object.keys(user.emiStatuses).includes(EMI.Wallester) ? (
            <NoPlans />
          ) : (
            <>
              <Typography.Title id='dashboard-title' className={classes.title} level={2}>
                {t({ id: 'screens.dashboard.title' })}
              </Typography.Title>
              <Plan
                planName={'Wallester'}
                emi={EMI.Wallester}
                accounts={accounts[EMI.Wallester]}
                status={user.emiStatuses[EMI.Wallester]}
                cards={cards[EMI.Wallester]}
              />

              {firstAccountId && (
                <div style={{ marginTop: 32 }}>
                  <TransactionsView accountId={firstAccountId} />
                </div>
              )}
            </>
          )}
        </div>
      </Container>

      <VerificationWidget emi={EMI.Wallester} />
    </>
  );
};
export default Dashboard;
